import { throwBadKind } from "../../utils/guards";
import { SearchAction } from "../actions";
import { SearchState } from "../SearchState";

export function RootReducer(state: SearchState, action: SearchAction): SearchState {
    const { type } = action;
    switch (type) {
        case "set-query":
            return {
                ...state,
                query: action.query
            };
        case "set-response":
            return {
                ...state,
                response: action.response,
                responseId: `${new Date().getTime()}`,
                responseQuery: action.query
            };
        case "new-search":
            return {
                ...state,
                query: {
                    text: "",
                    formats: []
                },
                response: undefined
            };
        case "set-modal-state":
            return {
                ...state,
                active: action.active,
                minimized: action.minimized,
                autoGreeting: action.autoGreeting
            };
        case "toggle-modal-state":
            const { active, minimized } = state;

            if (active || minimized) {
                return {
                    ...state,
                    active: false,
                    minimized: false
                };
            } else {
                return {
                    ...state,
                    active: false,
                    minimized: true
                };
            }
        default:
            throwBadKind(type);
    }
}